import React from "react";

export default function Footer() {
  return (
    <div className="card-footer p-1 text-center small">
      <a href="https://github.com/VladaHV/weather-react.git">
        Open-source code{" "}
      </a>
      by Vlada Honchar
    </div>
  );
}
